export default "__VITE_ASSET__CKMTcUPV__"